import React, { useState, useRef, useEffect, useContext } from 'react';
import classNames from 'classnames';
import * as Cookies from '../../platformui/Base/Cookies';
import { CookieContext } from '../../platformui/Context/cookies';
import { Spinner } from '../../platformui';

const COOKIE_NAME = 'showSensitiveImages';
const KEYCODE_ESC = 27;

const ArticleTools = (props) => {
  let timer = null;
  const [isRendered, setIsRendered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const isSensitiveActive =
    Cookies.parseCookieData(COOKIE_NAME, props.cookies) === 'false';
  const wrapperRef = useRef(null);

  useEffect(() => {
    //Listen for esc key
    const keyListener = (event) => {
      const keyCode = event.which || event.keyCode; // Get the current keycode

      if (keyCode === KEYCODE_ESC) setIsOpen(false);
    };

    document.addEventListener('keydown', keyListener, false);

    //Outside click
    document.addEventListener('click', handleClickOutside);
  }, []);

  const handleClickOutside = (e) => {
    if (wrapperRef && !wrapperRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  const context = useContext(CookieContext);

  if (props.PageTypeName !== 'ArticlePage') return null;
  if (!context.isAllowed('ShowSensitiveImagesCookie')) return null;

  const handleSetSensitiveImg = () => {
    if (isSensitiveActive) {
      Cookies.createCookie(COOKIE_NAME, 'true');
    } else {
      Cookies.createCookie(COOKIE_NAME, 'false');
    }

    setIsLoading(true);

    clearTimeout(timer);
    timer = setTimeout(() => {
      window.location.reload();
    }, 1200);
  };

  const handleOpenDialog = () => {
    if (isOpen && document.getElementById('sensitive-img-control')) {
      document.getElementById('sensitive-img-control').focus();
    }

    setIsOpen(!isOpen);
    setIsRendered(true);
  };

  const toggleSensitiveDialogClass = classNames({
    'c-article-tools__btn-container': true,
    'c-article-tools__btn-container--is-open': isOpen,
    'c-article-tools__btn-container--is-loading': isLoading,
  });

  const toggleBtnClasses = classNames({
    'c-article-tools__button': true,
    'c-article-tools__button--sensitive-img': true,
    'c-article-tools__button--is-active': isSensitiveActive,
  });

  return (
    <div ref={wrapperRef} className="c-article-tools">
      <div className={toggleSensitiveDialogClass}>
        <button
          className={toggleBtnClasses}
          id="sensitive-img-control"
          aria-controls="sensitive-img-dialog"
          aria-expanded={isOpen}
          onClick={() => handleOpenDialog()}
          type="button"
        >
          {isSensitiveActive && (
            <span>{props.Content.Translations.imagesarehidden}</span>
          )}
          {!isSensitiveActive && (
            <span>{props.Content.Translations.hideimages}</span>
          )}
        </button>

        <div
          id="sensitive-img-dialog"
          aria-hidden={!isOpen}
          className="c-article-tools__dialog"
        >
          {isRendered && (
            <div>
              <span className="c-article-tools__dialog__heading">
                {props.Content.SensetiveImagesHeading}
              </span>
              <span
                className="c-article-tools__dialog__text"
                dangerouslySetInnerHTML={{
                  __html: props.Content.SensetiveImagesText,
                }}
              />
              <button
                onClick={() => handleSetSensitiveImg()}
                className="c-article-tools__dialog__button"
                type="button"
              >
                {isSensitiveActive && (
                  <span className="c-article-tools__dialog__button__text">
                    {props.Content.Translations.showsensetiveimages}
                  </span>
                )}
                {!isSensitiveActive && (
                  <span className="c-article-tools__dialog__button__text">
                    {props.Content.Translations.hidesensetiveimages}
                  </span>
                )}
                <Spinner Modifiers={{ 'c-spinner--sensitive-img': true }} />
              </button>
              <button
                aria-controls="sensitive-img-dialog"
                aria-expanded={isOpen}
                onClick={() => handleOpenDialog()}
                className="c-article-tools__dialog__close"
                type="button"
              >
                <span className="show-for-sr">
                  {props.Content.Translations.closeimagedialog}
                </span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleTools;
